<!-- error-403 start-->
<div class="error-wrapper">
  <div class="container">
    <img class="img-100" src="assets/images/other-images/sad.png" alt="" />
    <div class="error-heading">
      <h2 class="headline font-warning">404</h2>
    </div>
    <div class="col-md-8 offset-md-2">
      <p class="sub-content">Page Not Found</p>
    </div>
    <div>
      <a class="btn btn-warning-gradien btn-lg" routerLink=""
        >BACK TO HOME PAGE</a
      >
    </div>
  </div>
</div>
<!-- error-403 end-->
